export default "__VITE_ASSET__ff878d97__"